export default {
  computed: {
    documentTemplateModules () {
      return [
        { name: 'customer', text: this.$t('message.layout.crm'), value: 1 },
        { name: 'order', text: this.$t('message.settings.order'), value: 2 }
        // { name: 'product', text: this.$t('message.layout.products'), value: 4 },
        // { name: 'warehouse', text: this.$t('message.layout.warehouse'), value: 3 }
      ]
    }
  },
  methods: {
    makeSureAndSetFolderId (module, recordId, getModuleTemplates = false) {
      this.$_executeApi('post', 'sharepoint/make_sure_record_sharepoint_folder', { module, record_id: recordId })
        .then(response => {
          this.sharepoint_id = response.data || ''
          const documentProperties = this.getAllDocumentsAndProperties()
          if (getModuleTemplates && documentProperties) {
            documentProperties.then(() => {
              this.getModuleTemplates()
            })
          }
        })
    }
  }
}
